module.exports = __webpack_public_path__ + "img/bubble4.198d4b1b.svg";